import { useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { Checkboxes } from 'features/tracked_meetings/share/send_email/checkboxes';
import { BodyField } from './body_field';
import { EmailSubjectField } from './email_subject_field';
import { EmailToField } from './email_to_field';
import { SendWithField } from './send_with';
const containerCss = "c1ivgde3";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const formContainerCss = "f13r8531";
const FormContainer = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(formContainerCss, props.className)} />);
const headerAlignmentContainerCss = "hd4q96j";
const HeaderAlignmentContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerAlignmentContainerCss, props.className)} />;
});
const dividerCss = "d1xkheej";
const Divider = forwardRef((props, ref) => <hr ref={ref} {...props} className={classNames(dividerCss, props.className)} />);
export const SendFromCalendlyEmailForm = ({
  emails,
  isLoading,
  initialBody
}) => {
  const {
    values,
    setFieldError,
    errors: {
      send_with: sendWithError,
      body: bodyError,
      subject: subjectError,
      to_addresses: toError
    }
  } = useFormContext();
  const clearSubjectError = useCallback(() => {
    setFieldError('subject', '');
  }, [setFieldError]);
  const clearToFieldError = useCallback(() => setFieldError('to_addresses', ''), [setFieldError]);
  const clearBodyError = useCallback(() => setFieldError('body', ''), [setFieldError]);
  return <Container>
      <HeaderAlignmentContainer>
        <BodyText size="medium" weight="bold">
          {I18n.t('publisher.meeting_intelligence.share.send_email_header')}
        </BodyText>
        <SendWithField errorMessage={sendWithError} name="send_with" emails={emails} disabled={isLoading} />
      </HeaderAlignmentContainer>
      <FormContainer>
        <EmailToField name="to_addresses" disabled={isLoading} onFocus={clearToFieldError} error={toError} />
        <Divider />
        <EmailSubjectField name="subject" errorMessage={subjectError} onFocus={clearSubjectError} disabled={isLoading} />
      </FormContainer>
      <BodyField name="body" errorMessage={bodyError} onFocus={clearBodyError} disabled={isLoading} initialBody={initialBody} />
      <Checkboxes formValues={values} />
    </Container>;
};

require("./form.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form.js");